
























































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import Locale from "@/service/Locale/Locale";

import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import {
  confirmed,
  email,
  numeric,
  required,
  max,
} from "vee-validate/dist/rules";

const quantityRule = {
  validate(value: string): boolean {
    return !!value.match(/^[0-9０-９,.\x20\u3000]*$/g); // 半角全角数字スペース、',', '.',
  },
};

extend("required", required);
extend("confirmed", confirmed);
extend("numeric", numeric);
extend("email", email);
extend("quantity_rule", quantityRule);
extend("max", max);

interface ContactValidationProps {
  actionUrl: string;
  csrfToken: string;
  lang: any;
  maxErrorText: string;
  dev: any;
  emailErrorText: string;
  locale: string;
  corp: string;
  url: string;
  nameOfPic: string;
  mailAddressOfPic: string;
  devices: string[];
  environments: string[];
  grade: string;
  quantity: number | string;
  content: string;
}

interface ContactValidationData {
  corpData: string;
  urlData: string;
  nameOfPicData: string;
  mailAddressOfPicData: string;
  mailAddressOfPicReentryData: string;
  devicesData: string[];
  environmentsData: string[];
  gradeData: string;
  displayQuantityData: string;
  contentData: string;
  agreeData: string[];
  contentRule: string;
  inputRule: string;
  radioRule: string;
  checkboxRule: string;
  mailAddressOfPicRule: string;
  mailAddressOfPicReentryRule: string;
  quantityRule: string;
  corpMaxLength: number;
  urlMaxLength: number;
  nameOfPicMaxLength: number;
  mailAddressOfPicMaxLength: number;
  contentMaxLength: number;
}

type Methods = {
  onSubmit: () => void;
};

// FIXME 引数のanyを修正する
export default Vue.extend<any, Methods, any, any>({
  name: "vc-contact-validation",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    actionUrl: {
      type: String as PropType<ContactValidationProps["actionUrl"]>,
      default: "",
    },
    csrfToken: {
      type: String as PropType<ContactValidationProps["csrfToken"]>,
      default: "",
    },
    lang: {
      type: Object as PropType<ContactValidationProps["lang"]>,
      default: () => {},
    },
    maxErrorText: {
      type: String as PropType<ContactValidationProps["maxErrorText"]>,
      default: "",
    },
    dev: {
      type: Object as PropType<ContactValidationProps["dev"]>,
      default: () => {},
    },
    emailErrorText: {
      type: String as PropType<ContactValidationProps["emailErrorText"]>,
      default: "",
    },
    locale: {
      type: String as PropType<ContactValidationProps["locale"]>,
      default: "",
    },
    corp: {
      type: String as PropType<ContactValidationProps["corp"]>,
      default: "",
    },
    url: {
      type: String as PropType<ContactValidationProps["url"]>,
      default: "",
    },
    nameOfPic: {
      type: String as PropType<ContactValidationProps["nameOfPic"]>,
      default: "",
    },
    mailAddressOfPic: {
      type: String as PropType<ContactValidationProps["mailAddressOfPic"]>,
      default: "",
    },
    devices: {
      type: Array as PropType<ContactValidationProps["devices"]>,
      default: () => [],
    },
    environments: {
      type: Array as PropType<ContactValidationProps["environments"]>,
      default: () => [],
    },
    grade: {
      type: String as PropType<ContactValidationProps["grade"]>,
      default: "",
    },
    quantity: {
      type: [Number, String] as PropType<ContactValidationProps["quantity"]>,
      default: 0,
    },
    content: {
      type: String as PropType<ContactValidationProps["content"]>,
      default: "",
    },
  },
  data(): ContactValidationData {
    return {
      corpData: this.corp,
      urlData: this.url,
      nameOfPicData: this.nameOfPic,
      mailAddressOfPicData: this.mailAddressOfPic,
      mailAddressOfPicReentryData: this.mailAddressOfPic,
      devicesData: this.devices || [],
      environmentsData: this.environments || [],
      gradeData: this.grade,
      displayQuantityData: String(this.quantity),
      contentData: this.content,
      agreeData: [],
      contentRule: "required|max:",
      inputRule: "required|max:",
      radioRule: "required:true",
      checkboxRule: "required:true",
      mailAddressOfPicRule: "required|email|max:",
      mailAddressOfPicReentryRule:
        "required|email|confirmed:mailAddressOfPicProvider|max:",
      quantityRule: "required|quantity_rule",
      corpMaxLength: 190,
      urlMaxLength: 255,
      nameOfPicMaxLength: 190,
      mailAddressOfPicMaxLength: 190,
      contentMaxLength: 10000,
    };
  },
  mounted() {
    const locale = Locale.getLocale();
    const requiredMessage = this.lang.error_form_required;
    localize(locale, {
      messages: {},
      fields: {
        corpProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.corpMaxLength),
        },
        urlProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.urlMaxLength),
        },
        nameOfPicProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.nameOfPicMaxLength),
        },
        devicesProvider: {
          required: requiredMessage,
        },
        environmentProvider: {
          required: requiredMessage,
        },
        gradeProvider: {
          required: requiredMessage,
        },
        quantityProvider: {
          required: requiredMessage,
          quantity_rule: this.lang.error_licence_format_invalid,
        },
        mailAddressOfPicProvider: {
          required: requiredMessage,
          email: this.emailErrorText,
          max: this.maxErrorText.replace(
            ":length",
            this.mailAddressOfPicMaxLength
          ),
        },
        mailAddressOfPicReentryProvider: {
          required: requiredMessage,
          email: this.emailErrorText,
          confirmed: this.lang.error_mail_address_unmatched,
          max: this.maxErrorText.replace(
            ":length",
            this.mailAddressOfPicMaxLength
          ),
        },
        contentProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.contentMaxLength),
        },
        agreeProvider: {},
      },
    });
  },
  computed: {
    parsedQuantityData() {
      return parseInt(
        this.displayQuantityData
          .replace(/[,.\x20\u3000]/g, "")
          .replace(/[０-９]/g, (num: string) =>
            String.fromCharCode(num.charCodeAt(0) - 0xfee0)
          )
      );
    },
  },
  methods: {
    onSubmit() {
      (this.$refs.form as HTMLFormElement).submit();
    },
  },
});
